import { HttpErrorResponse } from "@angular/common/http";
import { AfterViewInit, Component, Input, ViewChild, input } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { DxChartComponent, DxPieChartComponent } from "devextreme-angular";
import notify from "devextreme/ui/notify";
import { OcbFileTransferLogTypes, StatisticsService } from "../../core";
import { PieData } from "../../features";

@Component({
    selector: 'app-file-transfer-statistics',
    templateUrl: './file-transfer-statistics.component.html',
    styleUrls: ['./file-transfer-statistics.component.scss']
})
export class FileTransferStatisticsComponent implements AfterViewInit {
    @ViewChild('logsChart') chart: DxPieChartComponent;

    @Input() fileTransferName: string;

    protected dataSource: PieData[] = [];
    protected dataSourceSum = 0;

    private environmentId: string;
    private fileTransferId: string;
    private logsTypesLabels: any[];

    constructor(private statisticsService: StatisticsService,
        private route: ActivatedRoute,
        private translateService: TranslateService) {
    }

    ngAfterViewInit() {
        this.translateService.get('fileTransfersLogTypes').subscribe({
            next: (data) => this.logsTypesLabels = data,
                error: (e) => this.handleError(e)
            });

        this.route.params.subscribe(_ => {
            if (this.route.snapshot.params.ft === 'new') return;
            this.environmentId = this.route.snapshot.params.id;
            this.fileTransferId = this.route.snapshot.params.ft;

            this.statisticsService.getFileTransfersStatistics(this.environmentId, this.fileTransferId)
                .subscribe({
                    next: (res) => {
                        this.dataSource = [];
                        this.dataSourceSum = 0;
                        for (const lt in OcbFileTransferLogTypes) {
                            if (Number(lt)) {
                                const filtered = res.filter(log => log.eventType === Number(lt));
                                if (filtered.length > 0) {
                                    this.dataSource.push({
                                        eventType: this.logsTypesLabels[OcbFileTransferLogTypes[lt]],
                                        count: filtered[0].count,
                                    });
                                    this.dataSourceSum += filtered[0].count;
                                }
                            }
                        }
                    },
                    error: (err) => {
                        this.handleError(err);
                    }
                });
        });
    }

    private handleError(error: any): void {
        let message: '';
        if (error instanceof HttpErrorResponse) {
            if (error.error.hasOwnProperty('message')) message = error.error.message;
            else if (error.error.hasOwnProperty('name')) message = error.error.name;
            else message = error.error;
        }
        else message = error;
        notify(message, 'error', 3000);
    }
}